import React, { useState } from 'react';
import LoadPlanList from '../components/load-plan/LoadPlanList';
import LoadPlanForm from '../components/load-plan/LoadPlanForm';
import LoadPlanEditForm from '../components/load-plan/LoadPlanEditFrom';

const LoadPlan = () => {
    const [view, setView] = useState('list'); // 'list', 'form', 'edit'
    const [selectedPlan, setSelectedPlan] = useState(null);

    const handleCreateNew = () => {
        setSelectedPlan(null);
        setView('form');
    };

    const handleEditPlan = (plan) => {
        setSelectedPlan(plan);
        setView('edit');
    };

    const handleBackToList = () => {
        setSelectedPlan(null);
        setView('list');
    };

    return (
        <div className="h-full ">
            {
                view === 'list' ? (
                    <LoadPlanList
                        onCreateNew={handleCreateNew}
                        onEditPlan={handleEditPlan}
                    />
                ) : null
            }
            {
                view === 'form' ? (
                    <LoadPlanForm
                        onBack={handleBackToList}
                        planData={selectedPlan}
                    />
                ) : null
            }
            {
                view === 'edit' ? (
                    <LoadPlanEditForm
                        onBack={handleBackToList}
                        orderDataId={selectedPlan?.loId || null}
                    />
                ) : null
            }
        </div>
    );
};

export default LoadPlan;
